import { Observable } from "rxjs";
import { ReturnMessage } from "src/app/models/return-message";
import { AutocompleteDataLoader } from "./autocomplete-data-loader";
import { AutocompleteOption } from "./autocomplete-option";

export abstract class AbstractAutocompleteDataLoader implements AutocompleteDataLoader {

    abstract load(searchTerm: string): Observable<ReturnMessage<AutocompleteOption[]>>;
    abstract loadAll(): Observable<ReturnMessage<AutocompleteOption[]>>;
  
    fromDictionary(dictionary: any): AutocompleteOption[] {
      let options = [];
      for (let key in dictionary) {
        options.push({ id: key, description: dictionary[key] });
      }
      return options;
    }
    
  }